import React, { useState } from 'react'
import { UserColumns, UserData } from './UserData';
import DataTableHeader from '../../../../../Common/DataTableHeader/DataTableHeader';
import DataTable from '../../../../../Common/DataTable/DataTable';
import DataTableFooter from '../../../../../Common/DataTableFooter/DataTableFooter';

const UserTable = () => {

    const [data, setData] = useState(UserData)
    const handleDelete = (id) => {
        setData(prevData => prevData.filter(item => item.id !== id));
    }
    // {/* x---------------------------------x User Table Data x---------------------------------x */ }
    const dataT = data.map((data) => {
        return {
            id: data.id,
            name: data.name,
            image: (
                <img className="img-fluid avatar md rounded" alt="mainimage" src={data.image} />
            ),
            status: data.status,
            action: (
                <>
                    <button type="button" className="btn deleterow" onClick={() => handleDelete(data.id)}><i
                        className="bi bi-trash text-danger"></i></button>
                </>
            ),
        };
    });

    return (
        <div>
            {/* x---------------------------------x CommonDataTableHeader x---------------------------------x */}
            <DataTableHeader />

            {/* x---------------------------------x CommonDataTable x---------------------------------x */}
            <DataTable columns={UserColumns} data={dataT} />

            {/* x---------------------------------x CommonDataTableFooter x---------------------------------x */}
            <DataTableFooter dataT={dataT} />
        </div>
    )
}

export default UserTable